import { render, staticRenderFns } from "./BuyUser.vue?vue&type=template&id=4f76e573"
import script from "./BuyUser.vue?vue&type=script&lang=js"
export * from "./BuyUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports